export var RoleCompanyType;
(function (RoleCompanyType) {
    RoleCompanyType[RoleCompanyType["Group"] = 0] = "Group";
    RoleCompanyType[RoleCompanyType["Company"] = 1] = "Company";
    RoleCompanyType[RoleCompanyType["Site"] = 2] = "Site";
})(RoleCompanyType || (RoleCompanyType = {}));
